import { put, select } from 'lib/redux';
import getUserEntitlements from 'services/getUserEntitlements.service';
import * as types from 'constants/ActionTypes';
import { isObjectEmpty } from 'utils/app.utils';
import { logError } from 'utils/logger.utils';

export default function* getUserEntitlementsSaga() {
  try {
    const entitlements = yield select(({ userEntitlements }) => userEntitlements);
    if (!entitlements || isObjectEmpty(entitlements)) {
      const response = yield getUserEntitlements();
      if (!response.ok) {
        const error = new Error(response.json.errorDescription);
        error.errorCode = response.json.errorCode;
        throw error;
      }
      yield put({ type: types.GET_USER_ENTITLEMENTS_SUCCESS, entitlements: response.json.entitlements });
    }
  } catch (error) {
    logError('Error in getUserEntitlementsSaga', {
      error: error.message,
      errorCode: error.errorCode,
    });
  }
}
